import { T, backofficeUrl } from 'src/shared/helpers';

// The catalogue the onboarding prompt routes into. These mirror the solutions shown on the dashboard
// (components/pages/dashboard/solutions/solutions.tsx) so a suggestion always lands on a tool the
// seller can also find there afterwards.
export type OnboardingTool = {
    id: 'VC' | 'PC' | 'AI' | 'VTO' | 'DAM';
    name: string;
    description: string;
    ctaLabel: string;
    url: string;
};

export const ONBOARDING_TOOLS: OnboardingTool[] = [
    {
        id: 'VC',
        name: T._('Visual Product Customizer', 'Admin'),
        description: T._('Let customers personalize products in real time and get validated, production-ready output.', 'Admin'),
        ctaLabel: T._('Start with the Customizer', 'Admin'),
        url: backofficeUrl('/dashboard')
    },
    {
        id: 'PC',
        name: T._('3D Product Configurator', 'Admin'),
        description: T._('Interactive 3D product configuration with rule-based logic, components, and variants.', 'Admin'),
        ctaLabel: T._('Start with the Configurator', 'Admin'),
        url: backofficeUrl('/landings/configurator')
    },
    {
        id: 'AI',
        name: T._('AI Agents Studio', 'Admin'),
        description: T._('AI-powered tools to create mockups, renders, videos, and custom content.', 'Admin'),
        ctaLabel: T._('Start with AI Agents Studio', 'Admin'),
        url: backofficeUrl('/ai-creative-tools/studio')
    },
    {
        id: 'VTO',
        name: T._('Virtual Try-on', 'Admin'),
        description: T._('App-free AI-powered virtual try-on for eyewear, jewelry, hats, and more.', 'Admin'),
        ctaLabel: T._('Start with Virtual Try-on', 'Admin'),
        url: backofficeUrl('/virtual-try-on')
    },
    {
        id: 'DAM',
        name: T._('3D DAM & AR Viewer', 'Admin'),
        description: T._('Create, manage, optimize, and deploy web-ready 3D assets across every channel.', 'Admin'),
        ctaLabel: T._('Start with the 3D Viewer', 'Admin'),
        url: backofficeUrl('/DAM?page=/gallery')
    }
];

// The problems sellers arrive with, offered as ready-made prompts. Each one is written the way a
// seller would say it, and runs through the same suggestion path as free text.
export const PROMPT_PRESETS: string[] = [
    T._('I want to automate the sale of decorated products', 'Admin'),
    T._('I want to sell made-to-order products with options in 3D', 'Admin'),
    T._('I want product photos and mockups without a photo shoot', 'Admin'),
    T._('I want my customers to try my products on before buying', 'Admin'),
    T._('I want to showcase my products in 3D and AR on my store', 'Admin')
];

export type ToolSuggestion = {
    tool: OnboardingTool;
    // Alternatives to show under the main pick, so a wrong guess is never a dead end.
    alternatives: OnboardingTool[];
};
